export function BrandLogo() {
  return (
    <>
      <style>{`
        @keyframes sparkle {
          0%, 100% {
            opacity: 0;
            transform: scale(0);
          }
          50% {
            opacity: 1;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-2px);
          }
        }

        .sparkle-container {
          animation: float 3s ease-in-out infinite;
        }

        .sparkle {
          position: absolute;
          pointer-events: none;
        }

        .sparkle-dot {
          width: 2px;
          height: 2px;
          background: currentColor;
          border-radius: 50%;
          animation: sparkle 1.5s ease-out forwards;
        }
      `}</style>
      <div className="flex items-center gap-2">
        
        <span className="font-medium text-base tracking-tight">
FIXORIUM EXCHANGE
        </span>
      </div>
    </>
  );
}
